import * as React from 'react';
import { useReducer } from 'react';

import { Modal, FormGroup, Label, Input, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

type State = {
    name: string;
}

const initialState: State = {
    name: ""
}

function CreateNewCartModal(props: {
    open: boolean,
    onCancel: () => void,
    onAdd: (name: string) => void
}) {

    let [state, setState] = useReducer(
        (prevState: State, newState: Partial<State>) => ({ ...prevState, ...newState }),
        initialState
    );

    const cancel = () => {
        setState({ name: '' });
        props.onCancel();
    }

    return <>
        <Modal backdrop={'static'} isOpen={props.open} toggle={props.onCancel} size="md" className="modal-dialog-centered">
            <div className="modal-header">
                <h5 className="modal-title">Create new cart</h5>
                <button type="button" className="close" aria-label="Close"
                    onClick={cancel}><span aria-hidden="true"><i className="fa fa-times"></i></span></button>
            </div>

            <ModalBody>
                <FormGroup>
                    <Label for="cartName">Name</Label>
                    <Input
                        name="cartName" id="cartName" placeholder="Enter cart name"
                        style={{ height: "40px", paddingLeft: "7px" }}
                        value={state.name} onChange={(e) => setState({ name: e.target.value })}>
                    </Input>
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <div className="w-100 d-flex">
                    <Button color="white" className="mr-2 flex-fill" onClick={cancel}>Cancel</Button>
                    <Button color="white" className="btn btn-black d-inline-block border flex-fill" onClick={() => {
                        props.onAdd(state.name);
                        setState({ name: '' });
                    }}
                        disabled={!state.name || state.name.length === 0}>Save</Button>
                </div>
            </ModalFooter>
        </Modal>
    </>

}

export default CreateNewCartModal;
